/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.
import { environment } from "./environments/environment";

const awsmobile = {
  aws_project_region: "us-east-1",
  aws_appsync_graphqlEndpoint: environment.amplifyUrl,
  aws_appsync_region: "us-east-1",
  aws_appsync_authenticationType: "API_KEY",
  aws_appsync_apiKey: environment.amplifyApiKey,
};

export default awsmobile;
